function AutoCloseMenus() {
  // add event listener to all hamburger-checkbox
  document.querySelectorAll('.hamburger-checkbox').forEach((checkbox) => {
    checkbox.addEventListener('change', (e) => {
      // // get all hamburger-checkbox and by their data-target remove show class to the target, except the current one
      // const checkboxes = document.querySelectorAll('.hamburger-checkbox');
      // checkboxes.forEach((checkbox) => {
      //   const target = document.getElementById(checkbox.getAttribute('data-target') || '');
      //   if (target && checkbox !== e.target) {
      //     // uncheck the target checkbox
      //     (checkbox as HTMLInputElement).checked = false;
      //     // remove show class from the target
      //     target.classList.remove('show');
      //   }
      // });

      // if the current checkbox got checked then add show class to the target
      if ((e.target as HTMLInputElement).checked) {
        const target = document.getElementById((e.target as HTMLInputElement).getAttribute('data-target') || '');
        if (target) {
          target.classList.add('show');
        }
      } else {
        const target = document.getElementById((e.target as HTMLInputElement).getAttribute('data-target') || '');
        if (target) {
          target.classList.remove('show');
        }
      }
    });
  });
}

export default AutoCloseMenus;
